import { useState } from 'react';
import { EllipsisVertical, Pencil, Trash } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { TableCell, TableRow } from '@/components/ui/table';

import DeleteTaxDialog from './DeleteTaxDialog';
import EditTaxDialog from './EditTaxDialog';

const TaxRow = ({ tax }) => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const formatRate = (rate) => `${(rate / 100).toFixed(2)}%`;

  return (
    <>
      <TableRow>
        <TableCell className="py-2">{tax.name}</TableCell>
        <TableCell className="py-2">{tax.label}</TableCell>
        <TableCell className="py-2 text-right">
          {formatRate(tax.rate)}
        </TableCell>
        <TableCell className="text-right py-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="icon" size="icon" aria-label="Open menu">
                <EllipsisVertical size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuLabel>{tax.label}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => setIsEditDialogOpen(true)}>
                <Pencil className="mr-2 h-4 w-4" />
                Edit Tax
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className="text-destructive"
                onClick={() => setIsDeleteDialogOpen(true)}
              >
                <Trash className="mr-2 h-4 w-4" />
                Delete Tax
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>
      {isEditDialogOpen && (
        <EditTaxDialog tax={tax} setOpen={setIsEditDialogOpen} />
      )}
      {isDeleteDialogOpen && (
        <DeleteTaxDialog tax={tax} setOpen={setIsDeleteDialogOpen} />
      )}
    </>
  );
};

export default TaxRow;
